"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Magnifyingglass = function Magnifyingglass(_ref) {
  var title = _ref.title,
      description = _ref.description,
      width = _ref.width,
      height = _ref.height,
      rest = _objectWithoutProperties(_ref, ["title", "description", "width", "height"]);

  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    "aria-hidden": !title,
    "aria-labelledby": "MagnifyingglassTitle MagnifyingglassDescription",
    height: height,
    preserveAspectRatio: "none",
    role: "img",
    viewBox: "0 0 24 24",
    width: width
  }, rest), /*#__PURE__*/_react["default"].createElement("title", {
    id: "MagnifyingglassTitle"
  }, title), /*#__PURE__*/_react["default"].createElement("desc", {
    id: "MagnifyingglassDescription"
  }, description), /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("path", {
    transform: "scale(1 1)",
    d: "M18.786 17.753l-3.381-3.382a5.82 5.82 0 0 0-.483-7.669A5.774 5.774 0 0 0 10.812 5a5.773 5.773 0 0 0-4.11 1.702A5.773 5.773 0 0 0 5 10.812c0 1.552.605 3.012 1.702 4.11a5.774 5.774 0 0 0 4.11 1.702c1.306 0 2.545-.43 3.56-1.219l3.38 3.381a.728.728 0 0 0 1.034 0 .731.731 0 0 0 0-1.033zm-11.05-3.865a4.323 4.323 0 0 1-1.275-3.076 4.32 4.32 0 0 1 1.275-3.076 4.321 4.321 0 0 1 3.076-1.275c1.162 0 2.255.453 3.077 1.275a4.355 4.355 0 0 1 0 6.152 4.323 4.323 0 0 1-3.077 1.275 4.323 4.323 0 0 1-3.077-1.275z",
    id: "refMagnifyingglassYfW864uBa0G"
  })), /*#__PURE__*/_react["default"].createElement("use", {
    xlinkHref: "#refMagnifyingglassYfW864uBa0G"
  }));
};

Magnifyingglass.defaultProps = {
  description: '',
  height: 24,
  title: null,
  width: 24
};
Magnifyingglass.propTypes = {
  description: _propTypes["default"].string,
  height: _propTypes["default"].number,
  title: _propTypes["default"].string,
  width: _propTypes["default"].number
};
var _default = Magnifyingglass;
exports["default"] = _default;